export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9491.dc28f07f.jpg";